import React from 'react'
import { Main, MainTop, MainTopTitle, MainBody } from '@/components/Layout'
import { connect } from 'react-redux'
import context from '@/context'
import { BsrsGrid } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { localized } from '@/decorators/localized'
import { dialogTypes } from '@/dialogs'
import Resx from '@/components/Resx'
import getComponentKey from '@/utils/getComponentKey'
import { previewHelpContentActionsCell } from './actionButtonCell'
import { format } from '@/utils/StringUtilities'

@localized()
class HelpPages extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      updating: false,
      gridKey: getComponentKey()
    }
  }
  validate (value) {
    const { localize } = this.props
    if (!value || value.length === 0) { return format(localize('Validations.Required'), 'Key') }
    if (value.length > 100) { return localize('Validations.MaxLengthExceeded') }
    return null
  }
  showError = (err) => {
    this.props.openDialog({
      dialogType: dialogTypes.alert,
      title: 'Common.Error',
      localizedContent: err
    })
  }
  onItemEdited (editedItem) {
    const { value } = editedItem
    const validationResult = this.validate(value)
    if (validationResult) {
      this.showError(validationResult)
      this.setState({ gridKey: getComponentKey() })
    } else {
      this.setState({ updating: true }, () => {
        const input = { id: editedItem.item.id, key: value }
        context.api.helpService.updateKey(input)
          .then(r => {
            if (r !== true) { this.showError() }
            this.setState({ updating: false, gridKey: getComponentKey() })
          })
          .catch(err => {
            this.setState({ updating: false, gridKey: getComponentKey() })
            this.props.showError(err)
          })
      })
    }
  }
  preview = (item) => {
    this.props.openDialog({
      dialogType: dialogTypes.helpPreview,
      helpKey: item.key
    })
  }
  render () {
    const { localize } = this.props
    return (
      <Main>
        <MainTop>
          <MainTopTitle><Resx name='Common.HelpPagesTitle' /></MainTopTitle>
        </MainTop>
        <MainBody>
          <BsrsGrid
            persistenceId={'help-pages'}
            dataSource={context.api.helpService.getTableData}
            exitEditingOnEnter
            editable={!this.state.updating}
            onItemEdited={(editedItem) => this.onItemEdited(editedItem)}
            disableExcelExport
            lastReloadedAt={this.state.gridKey}
          >
            <Column field='id' title={localize('Common.Id')} editable={false} filter='numeric' width='100px' />
            <Column field='key' title={localize('Common.Key')} editable />
            <Column {...previewHelpContentActionsCell({ onPreview: this.preview, localize })} />
          </BsrsGrid>
        </MainBody>
      </Main>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...ownProps
})

const mapDispatchToProps = {
  openDialog: dialogActions.openDialog
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpPages)



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/helpPages/list.js